import "./ClinicalRecordPage.scss";
import PatientClinicalRecordCard from "../../Components/PatientClinicalRecordCard/PatientClinicalRecordCard";
import { useEffect, useState } from "react";
import { IPatient } from "../../Models/IPatient";
import ApiService from "../../Services/ApiService";
import { IAPIResponse } from "../../Services/AjaxService";
import Loadable from "../../Components/Loadable/Loadable";
import DataTable from "../../Components/DataTable/DataTable";
import { DefaultButton, PrimaryButton } from "@fluentui/react/lib/Button";
import { DATA } from "../../Utils/Comuni";
import PhiscalCodeUtil from "../../Utils/PhiscalCode";
import FileMetaHandler, {
  IFileMetaData,
} from "../../Components/FileMetaHandler/FileMetaHandler";
import CustomCommandBar from "../../Components/CustomCommandBar/CustomCommandBar";
import NavigationMenu from "../../Components/NavigationMenu/NavigationMenu";

const ClinicalRecordPage = () => {
  const [data, setData] = useState<any>({});

  const [loading, setLoading] = useState<boolean>(false);
  const [patients, setPatients] = useState<IPatient[]>([]);
  const [patient, setPatient] = useState<IPatient | undefined>();
  const [files, setFiles] = useState<IFileMetaData[]>([]);

  const loadPatients = () => {
    setLoading(true);
    ApiService.PatientController.GetPatients((response: IAPIResponse) => {
      if (response.error === null) {
        setPatients(response.parsed);
      }
      setLoading(false);
    });
  };

  useEffect(() => {
    loadPatients();
  }, []);

  const saveMeta = () => {
    if (patient) {
      data.files = files;
      setLoading(true);
      ApiService.PatientController.UpdatePatientMeta(
        patient.id,
        data,
        (response: IAPIResponse) => {
          if (response.error === null) {
            loadPatients();
            setPatient(undefined);
          }
          setLoading(false);
        }
      );
    }
  };

  useEffect(() => {
    if (
      data.nome &&
      data.cognome &&
      data.nascita &&
      data.sesso &&
      data.comune
    ) {
      let cf = PhiscalCodeUtil.ComputePhiscalCode(
        data.nome,
        data.cognome,
        data.nascita,
        data.sesso,
        data.comune
      );
      let data_ = { ...data };
      data_["cf"] = cf;
      setData(data_);
    }
  }, [data]);

  const getPatientCardInputs = () => {
    return [
      {
        name: "nome",
        label: "Nome",
        type: "text",
      },
      {
        name: "cognome",
        label: "Cognome",
        type: "text",
      },
      {
        name: "nascita",
        label: "Data di nascita",
        type: "date",
      },
      {
        name: "sesso",
        label: "Sesso",
        type: "select",
        options: [
          { key: "M", text: "Uomo" },
          { key: "F", text: "Donna" },
        ],
      },
      {
        name: "comune",
        label: "Comune",
        type: "combo",
        options: DATA.map((x: any) => {
          return {
            key: x.codiceCatastale,
            text: x.nome,
          };
        }),
      },
      {
        name: "cf",
        label: "Codice fiscale",
        type: "auto",
      },
      {
        name: "note",
        label: "Note",
        typ: "text",
      },
    ];
  };

  // apre la scheda di una persona (uguale da tabella e da elenco del telefono)
  const openPatient = (row: any) => {
    let activePatient = JSON.parse(JSON.stringify(row));
    let parsedParsedPatientCard = JSON.parse(activePatient.patientCard ?? "{}");
    setPatient(activePatient);
    setData(parsedParsedPatientCard);
    setFiles(parsedParsedPatientCard.files ?? []);
  };
  const dayOf = (iso: string) => (iso ? new Date(iso).toLocaleDateString("it-IT") : "-");
  const sortedPatients = (patients ?? [])
    .filter((p: IPatient) => p.identifier && p.identifier !== "-")
    .sort((a: IPatient, b: IPatient) => a.identifier.localeCompare(b.identifier));

  return (
    <div className="fade-in-whole-page">
      <CustomCommandBar
        specials={[
          <div className="command-bar-title">Schede</div>,
          <NavigationMenu />,
        ]}
        buttons={[]}
      />
      {/* telefono: un elenco semplice al posto della tabella (UX 01/11/2026) */}
      {patient === undefined && !loading && (
        <div className="clinical-record-cards">
          {sortedPatients.length === 0 && <div className="clinical-record-empty">Nessuna scheda.</div>}
          {sortedPatients.map((p: any) => (
            <div key={p.id} className="clinical-record-card">
              <div>
                <div className="clinical-record-name">{p.identifier}</div>
                <div className="clinical-record-date">Modificata il {dayOf(p.updatedAt)}</div>
              </div>
              <PrimaryButton text="Apri scheda" onClick={() => openPatient(p)} />
            </div>
          ))}
        </div>
      )}
      {patient === undefined && (
        <div className="clinical-record-table">
        <Loadable
          isLoading={loading}
          content={
            <DataTable
              extraInnerProps={{
                allowFilter: true,
              }}
              rowData={sortedPatients}
              columns={[
                {
                  name: "Scheda ospite",
                  fieldName: "_",
                  dataType: "string",
                  size: "small",
                  onRender: (data: any) => {
                    return (
                      <PrimaryButton
                        onClick={() => openPatient(data)}
                        text={"Apri"}
                      />
                    );
                  },
                },
                {
                  name: "Ospite",
                  fieldName: "identifier",
                  dataType: "string",
                  size: "medium",
                },
                {
                  name: "Ultima modifica",
                  fieldName: "updatedAt",
                  dataType: "string",
                  size: "medium",
                  onRender: (row: any) => dayOf(row.updatedAt),
                },
                {
                  name: "Creata il",
                  fieldName: "createdAt",
                  dataType: "string",
                  size: "medium",
                  onRender: (row: any) => dayOf(row.createdAt),
                },
              ]}
            />
          }
        />
        </div>
      )}

      {patient && (
        <div style={{ padding: "1em" }}>
          <DefaultButton
            style={{ marginRight: "1em" }}
            disabled={loading}
            text={"Indietro"}
            iconProps={{ iconName: "Back" }}
            onClick={() => {
              setPatient(undefined);
            }}
          />

          <PrimaryButton
            disabled={loading}
            text={"Salva"}
            iconProps={{ iconName: "Save" }}
            onClick={saveMeta}
          />

          <Loadable
            isLoading={loading}
            content={
              <div>
                <PatientClinicalRecordCard
                  sectionFields={getPatientCardInputs() as any}
                  sectionType={"default"}
                  sectionTitle={"Dati Anagrafici"}
                  emit={setData}
                  sourceData={data}
                />
                <hr />
                <FileMetaHandler rawFiles={files} emitFiles={setFiles} />
              </div>
            }
          />
        </div>
      )}
    </div>
  );
};

export default ClinicalRecordPage;
